import React from 'react';
import i18next from 'i18next';

import type { DetailsPageProps, ViewPageProps } from 'app/main/components/page-layouts';
import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import PeopleListItem from './PeopleListItem';
import PeopleDetails from './details/PeopleDetails';

import buttons from './PeopleButtons';
import events from './PeopleEvents';

import en from './i18n/en';
import it from './i18n/it';

const ViewPage = lazyRetry<ViewPageProps>(() => import('app/main/components/page-layouts/view/ViewPage'));
const DetailsPage = lazyRetry<DetailsPageProps>(() => import('app/main/components/page-layouts/details/DetailsPage'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	auth: ({ isModuleDisabled }) => isModuleDisabled('people'),
	routes: [
		{
			path: 'people/add/:tabId?',
			auth: ({ authorizer }) => authorizer.can('create', 'people'),
			element: (
				<DetailsPage
					key="people/add"
					module="people"
					headerOptions={{ showAvatar: true }}
					tabs={PeopleDetails}
					buttons={buttons.details}
					events={events}
					isAdd
				/>
			)
		},
		{
			path: 'people/details/:id/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'people'),
			element: (
				<DetailsPage
					key="people/details"
					module="people"
					headerOptions={{ showAvatar: true }}
					tabs={PeopleDetails}
					buttons={buttons.details}
					events={events}
				/>
			)
		},
		{
			path: 'people/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'people'),
			element: (
				<ViewPage
					key="people/view"
					module="people"
					content={{ type: 'list', itemLayout: PeopleListItem, id: 'peopleView' }}
					buttons={buttons.view}
				/>
			)
		}
	]
};

export default routes;
